import { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { MobileBottomNav } from "./MobileBottomNav";
import { ContextStatusBar } from "./ContextStatusBar";
import { SidebarProvider } from "@/shared/components/ui/sidebar";
import { useIsMobile } from '@/shared/hooks';
import { useAuth } from "@/core/auth/AuthProvider";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const isMobile = useIsMobile();
  const { hasRole } = useAuth();
  const showContextBar = hasRole("admin");
  
  return (
    <SidebarProvider defaultOpen={!isMobile}>
      <div className="min-h-screen flex w-full bg-background">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <Header />
          {showContextBar && <ContextStatusBar className="hidden md:flex" />}
          <main className="flex-1 min-w-0 pb-20 md:pb-0">
            <div className="w-full min-w-0 px-4 md:px-6 py-4 page-enter">{children}</div>
          </main>
        </div>
        <MobileBottomNav />
      </div>
    </SidebarProvider>
  );
}
